module.exports = __webpack_public_path__ + "img/76betLogo.913ca2ba.png";